export const handleTamper = (response, config) => {
    if (!(config === null || config === void 0 ? void 0 : config.enabled) || !config.modifyResponse) {
        return response; // No tampering
    }
    return config.modifyResponse(response);
};
